import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';

const PrintViewModal = React.forwardRef((props, ref) => {
    const [height, setHeight] = useState(0);
    //const width = window.innerWidth
    //    ? window.innerWidth
    //    : document.documentElement.clientWidth
    //        ? document.documentElement.clientWidth
    //        : window.screen.width
    //const height = window.innerHeight
    //    ? window.innerHeight
    //    : document.documentElement.clientHeight
    //        ? document.documentElement.clientHeight
    //        : window.screen.height

    useEffect(() => {
        var height = window.innerHeight
            ? window.innerHeight
            : document.documentElement.clientHeight
                ? document.documentElement.clientHeight
                : window.screen.height
        height = height - 200;
        setHeight(height);
    }, [])

    //const printContents = () => {
    //    var content = document.getElementById("printViewContent")
    //    var originalWindowContent = document.body.innerHTML;
    //    let myWindow = window.open('', '_blank', ``);
    //    myWindow.document.write(content.innerHTML);
    //    copyStyles(document, myWindow.document);
    //    myWindow.document.title = props.documentTitle;
    //    //myWindow.window.print();
    //    //myWindow.document.write("<script type=\"text/javascript\">window.print();setTimeout(() => window.close(), 10);</script >");

    //}

    function copyStyles(source, target) {
        // Store style tags, avoid reflow in the loop
        const headFrag = target.createDocumentFragment()

        Array.from(source.styleSheets).forEach(styleSheet => {
            // For <style> elements
            let rules
            try {
                rules = styleSheet.cssRules
            } catch (err) {
                console.error(err)
            }
            if (rules) {
                // IE11 is very slow for appendChild, so use plain string here
                const ruleText = []

                // Write the text of each rule into the body of the style element
                Array.from(styleSheet.cssRules).forEach(cssRule => {
                    const { type } = cssRule

                    // Skip unknown rules
                    if (type === CSSRule.UNKNOWN_RULE) {
                        return
                    }

                    let returnText = ''

                    if (type === CSSRule.KEYFRAMES_RULE) {
                        // IE11 will throw error when trying to access cssText property, so we
                        // need to assemble them
                        returnText = getKeyFrameText(cssRule)
                    } else if (
                        [CSSRule.IMPORT_RULE, CSSRule.FONT_FACE_RULE].includes(type)
                    ) {
                        // Check if the cssRule type is CSSImportRule (3) or CSSFontFaceRule (5)
                        // to handle local imports on a about:blank page
                        // '/custom.css' turns to 'http://my-site.com/custom.css'
                        returnText = fixUrlForRule(cssRule)
                    } else {
                        returnText = cssRule.cssText
                    }
                    ruleText.push(returnText)
                })

                const newStyleEl = target.createElement('style')
                newStyleEl.textContent = ruleText.join('\n')
                headFrag.appendChild(newStyleEl)
            } else if (styleSheet.href) {
                // for <link> elements loading CSS from a URL
                const newLinkEl = target.createElement('link')

                newLinkEl.rel = 'stylesheet'
                newLinkEl.href = styleSheet.href
                headFrag.appendChild(newLinkEl)
            }
        })

        function getKeyFrameText(cssRule) {
            const tokens = ['@keyframes', cssRule.name, '{']
            Array.from(cssRule.cssRules).forEach(cssRule => {
                // type === CSSRule.KEYFRAME_RULE should always be true
                tokens.push(cssRule.keyText, '{', cssRule.style.cssText, '}')
            })
            tokens.push('}')
            return tokens.join(' ')
        }

        target.head.appendChild(headFrag)
    }

    return (
        <>
            <Modal.Header><b>{props.title}</b></Modal.Header>
            <Modal.Body>
                <div id="printViewContent" style={{ overflowY: "scroll", maxHeight: height }}>
                    <div ref={ref}>
                        {props.controlToPrint}
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="light" onClick={props.closeModal}>Close</Button>
                <Button variant="primary" onClick={() => printContents()}>Print</Button>
            </Modal.Footer>
        </>
    );
});

export default PrintViewModal